import type { ReactNode } from 'react';
import { cn } from '@azelis/ui/lib/utils';

/** Shared layout for a titled section within the documents tabs: heading, optional action, content. */
export function DocumentsColumn({
  action,
  children,
  className,
  title,
}: {
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  title: string;
}) {
  return (
    <section className={cn('flex flex-col gap-6', className)}>
      <div className="flex flex-col items-start gap-2">
        <h2 className="text-lg font-semibold leading-7 text-muted-foreground">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
